// ⚠ 반드시 첫 import — 화상통화(simple-peer)가 쓰는 process.nextTick을 채운다. 빠지면 통화가 연결되지 않는다(processShim.ts 머리 주석)
import './utils/processShim';
import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import { ToastProvider } from './contexts/ToastContext';
import { GlobalTooltip } from './components/GlobalTooltip';
import { installDesktopContextMenuGuard } from './utils/tauri';

const rootElement = document.getElementById('root');
if (!rootElement) {
  throw new Error("Could not find root element to mount to");
}

const root = ReactDOM.createRoot(rootElement);
root.render(
  <React.StrictMode>
    <ToastProvider>
      <App />
      {/* 전역 툴팁 — App의 return이 4갈래(다운로드/도움말/로그인/메인)라 여기서 한 번만 마운트한다.
          이 줄을 지우면 브라우저 기본 title 툴팁 동작으로 즉시 되돌아간다 */}
      <GlobalTooltip />
    </ToastProvider>
  </React.StrictMode>
);

// 데스크톱 앱에서 빈 곳 우클릭 시 WebView2 기본 메뉴 차단 (웹·PWA는 no-op)
installDesktopContextMenuGuard();

// PWA 서비스워커 등록 (웹 전용, Tauri 환경 제외)
if ('serviceWorker' in navigator && !(window as any).__TAURI_INTERNALS__) {
  window.addEventListener('load', () => {
    navigator.serviceWorker
      .register('./service-worker.js')
      .then((reg) => {
        console.log('[SW] Registered:', reg.scope);

        // 60분마다 서비스워커 업데이트 확인
        setInterval(() => { reg.update().catch(() => {}); }, 60 * 60 * 1000);

        // 새 서비스워커 감지 시 사용자에게 알림
        reg.addEventListener('updatefound', () => {
          const newWorker = reg.installing;
          if (!newWorker) return;
          newWorker.addEventListener('statechange', () => {
            if (newWorker.state === 'installed' && navigator.serviceWorker.controller) {
              window.dispatchEvent(new CustomEvent('sw-update-available'));
            }
          });
        });
      })
      .catch((err) => console.warn('[SW] Registration failed:', err));
  });
}